/* Footer columns (sections/footer.liquid).

   The columns fold below 768px. The server writes aria-expanded="false" and CSS keeps the panel
   on a 0fr row; this file only flips the attribute. Without it the panel stays open at every
   width (.no-js in assets/section-footer.css), so nothing is unreachable if the module fails.

   Above 768px the title is not a control — CSS takes the pointer events off it — so the click
   listener never fires there and no media query is tracked here. */

document.addEventListener('click', (event) => {
  const toggle = event.target instanceof Element ? event.target.closest('[data-footer-toggle]') : null;
  if (!toggle) return;
  toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
});
